/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment } from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';

import './HomePage.scss';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();
  return (
    <Fragment>
      <Grid container marginTop={2} justifyContent="center">
        <Grid item sx={{ maxWidth: 420 }}>
          <Paper sx={{ p: 3, ml: 2, mr: 2 }}>
            <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
              Søk om parkeringstillatelse
            </Typography>
            <Typography variant="body1" component="p" sx={{ mb: 2 }}>
              Her kan du søke om parkeringstillatelse for å parkere
              kostnadsfritt på en av Lufthavnene til Avinor som er regulert av
              Onepark.
            </Typography>
            <Typography variant="body1" component="p">
              Du velger selv hvilken lufthavn din forespørsel gjelder og hvilken
              kontaktperson på lufthavnen som skal godkjenne forespørselen.
            </Typography>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '26px',
              }}
            >
              <Button
                variant="contained"
                size="large"
                sx={{
                  pl: 4,
                  pr: 4,
                  backgroundColor: '#84216B',
                  '&:hover': {
                    backgroundColor: '#470A59',
                  },
                }}
                onClick={() => {
                  navigate(`/request/new`);
                }}
              >
                Fyll inn forespørsel
              </Button>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default HomePage;
